// extracted by mini-css-extract-plugin
module.exports = {"userInfo":"Other_userInfo__mrm-d","userAvatar":"Other_userAvatar__3zcFP","userName":"Other_userName__3QLsg"};